import 'slick-carousel';
import $log from './../util/logger';
//import shuffleElements from './../util/shuffleElements';

class IJkelenstamHome {
  constructor() {
    $log.debug('IJkelenstamHome => constructor');

    this.buildHeroSlider();
    this.buildQuoteSlider();
    this.buildBrandsSlider();
  }

  buildHeroSlider() {
    $log.debug('IJkelenstamHome => buildHeroSlider');

    const $slider = $("[data-slider='hero']");
    //const numberOfQuotes = $quotes.find('blockquote').length;
    // const randomQuote = Math.floor(Math.random() * Math.floor(numberOfQuotes));
    const $controls = $("[data-slider-controls='hero']");

    // Initialize slick carousel
    $slider.slick({
      appendDots: $controls,
      fade: true,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 2000,
    });
  }

  buildQuoteSlider() {
    $log.debug('IJkelenstamHome => buildQuoteSlider');

    const $quotes = $("[data-slider='quote']");
    const numberOfQuotes = $quotes.find('blockquote').length;
    const randomQuote = Math.floor(Math.random() * Math.floor(numberOfQuotes));
    const $controls = $("[data-slider-controls='quote']");

    // Initialize slick carousel
    $quotes.slick({
      initialSlide: randomQuote,
      appendArrows: $controls,
    });
  }

  buildBrandsSlider() {
    $log.debug('IJkelenstamHome => buildBrandsSlider');

    const $brands = $("[data-slider='brands']");
    //const numberOfQuotes = $quotes.find('blockquote').length;
    //const randomQuote = Math.floor(Math.random() * Math.floor(numberOfQuotes));
    //const $controls = $("[data-slider-controls='quote']");

    // shuffleElements(document.querySelectorAll('.brands-slider__item'));

    // Initialize slick carousel
    $brands.slick({
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            infinite: true,
          },
        },
        {
          breakpoint: 300,
          settings: {
            slidesToShow: 6,
          },
        },
      ],
      slidesToShow: 5,
      arrows: false,
      swipeToSlide: true,
      autoplay: true,
      // appendArrows: $controls,
    });
  }
}

export default IJkelenstamHome;
